/**
 * 优惠券配置项
 */
export type CouponItemCfg = {
  /** 活动加密串 */
  actIdEn: string,
  /** 开始时间 */
  startTime: string,
  /** 结束时间 */
  endTime: string
};
export enum MerchantType {
  /** 单个商户 */
  single,
  /** 商圈 */
  mall,
}
/**
 * 银行券列表
 */
export type BankActItemCfg = {
  /** 活动标题 */
  title: string;
  /** 开始时间 */
  startTime: string;
  /** 结束时间 */
  endTime: string;
  /** 左上角标签 */
  tag: string;
  /** 模块背景图 */
  bgImg: string;
  /** 活动Id列表 */
  actIdList: {
    /** 活动加密串-适用于手动领券活动 */
    actIdEn: string;
  }[];
  actImgList: {
    /** 活动展示位图片-适用于立减等活动 */
    imgUrl: string;
  }[];
  /** 条款与细则 */
  tncUrl: string;
};
/**
 * 商户基本信息
 */
export type MerchantBaseInfo = {
  /** 商户id */
  mrchId: string;
  /** 商户名称 */
  mrchName: string; // TODO: 多语言 mrchNameEn
  /** 商户logo */
  mrchLogo: string;
  /** 商户背景图（顶部） */
  backgroundImg: string; // TODO: 多语言
  /** 商户主题色 */
  spId: string;
  simpleCouponList: CouponItemCfg[],
  /** 银行券列表 */
  bankCouponList: BankActItemCfg[],
  /** 连锁券列表 */
  chainCouponList: CouponItemCfg[],
  /** 商户类型 */
  mrchType: MerchantType,
};

/** 包括多语言字段的商户信息 */
export type OriginalMerchantBaseInfo = MerchantBaseInfo & {
  mrchNameEn: string;
  backgroundImgEn: string;
};
